// extracted by mini-css-extract-plugin
module.exports = {"tip":"styles_tip__Vi4MI"};